import React from 'react';
import { currencyFormatNumber, currencyFormatNumberWithSign, envConfig } from '../../../../utils/config';

interface CustomInputPreviewProps {
  className?: string;
  value?: string | number;
  style?: React.CSSProperties;
  size?: 'lg' | 'md' | 'sm'; // NEW
  type?: 'text' | 'number' | 'currency'
}

const CustomInputPreview: React.FC<CustomInputPreviewProps> = ({
  value = '',
  className,
  style={},
  size = envConfig.DEFAULT_INPUT_FIELD_SIZE, // DEFAULT
  type = 'text'
}) => {

  // Determine size class
  const sizeClass =
    size === 'lg'
      ? 'form-control-lg'
      : size === 'sm'
        ? 'form-control-sm'
        : 'form-control-md';

  // Final className
  const finalClassName =
    className || `form-control ${sizeClass} bg-gray-200`;
  const inputFormat=(value : string | number)=>{
    switch(type){
      case "number":
        return currencyFormatNumber(value);
      case "currency":
        return currencyFormatNumberWithSign(value);
      default:
        return value;
    }
  }
  return <span className={finalClassName} style={style}>{inputFormat(value)}</span>;
};

export default CustomInputPreview;